import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    
    const api = BaseApi.create({
        timeout: 100000
    });

    const searchClients = (searchCriteria) => api.get(ApiPaths.SEARCH_CLIENTS(searchCriteria));

    const createSearchLog = (action) => {
        var payload = {
            "id": action.id,
            "type": action.type
        }
        return api.post(ApiPaths.AUDIT, payload);
    }   

    const getAccountHistory = (id) => api.get(ApiPaths.GET_ACCOUNT_HISTORY(id));
    const getSecurityInfo = (id) => api.get(ApiPaths.GET_SECURITY_INFO(id));
    const getClient = (id) => api.get(ApiPaths.GET_CLIENT(id));

    const searchReturns = (action) => {
        if(action.isVmid) {
           return api.get(ApiPaths.GET_FILED_RETURNS(action.id, action.taxYear));
        }
        return api.get(ApiPaths.GET_FILED(action.id, action.taxYear));
    }

    const searchAssociatedReturn = (action) => api.get(ApiPaths.GET_ASSOCIATED_RETURNS(action.id, action.taxYear));

    const getParty = (action) => api.get(ApiPaths.GET_PARTY(action.partyId));

    // Return back a collection of functions
    return {
        searchClients, 
        getAccountHistory,
        createSearchLog,
        getSecurityInfo,
        getClient,
        searchReturns,
        searchAssociatedReturn,
        getParty
    }
}

// let's return back our create method as the default.
export default {
    create
}
